

require('./bootstrap');

window.toastr = require("toastr");
window.toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "500",
    hideDuration: "500",
    timeOut: "4000",
    extendedTimeOut: "500",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

$(function () {
    const $textarea = $("textarea");
    const $charCountDisplay = $("#charCount");
    const formatCharCount = (count) => `${count} characters`;

    if ($charCountDisplay.length && $textarea.length) {
        $charCountDisplay.text(formatCharCount($textarea.val().length));
    }

    $textarea.on("input", function () {
        const currentLength = $(this).val().length;
        $charCountDisplay.text(formatCharCount(currentLength));
    });

    $("[data-toggle=\"tooltip\"]").tooltip();
});

$(document).on("click", ".js-password-toggle", function () {
    const $button = $(this);
    const targetId = $button.data("target");

    if (!targetId) {
        return;
    }

    const $input = $(`#${targetId}`);

    if (!$input.length) {
        return;
    }

    const isPassword = $input.attr("type") === "password";
    const $icon = $button.find("i");
    const showLabel = $button.data("label-show") || "Show password";
    const hideLabel = $button.data("label-hide") || "Hide password";

    $input.attr("type", isPassword ? "text" : "password");
    $button.attr("aria-pressed", isPassword ? "true" : "false");
    $button.attr("aria-label", isPassword ? hideLabel : showLabel);
    $button.attr("title", isPassword ? hideLabel : showLabel);

    if ($icon.length) {
        $icon.toggleClass("fa-eye", !isPassword).toggleClass("fa-eye-slash", isPassword);
    }
});


const bulkSmsSendForm = $("#bulkSmsSendForm");
const templatePreview = $("#selectedTemplatePreview");
const templateName = $("#selectedTemplateName");
const templateBody = $("#selectedTemplateBody");
const templateLength = $("#selectedTemplateLength");
const clientCount = $("#selectedClientCount");
const clientList = $("#client-list");

const updateClientCount = () => {
    if (!clientList.length || !clientCount.length) {
        return;
    }

    const count = clientList.find("input[type='checkbox']:checked").length;
    clientCount.text(count);
};

if (clientList.length) {
    clientList.on("change", "input[type='checkbox']", updateClientCount);
}

bulkSmsSendForm.on("show.bs.modal", function (event) {
    const button = $(event.relatedTarget);
    const templateId = button.data("template");
    const name = button.data("template-name") || "";
    const body = button.data("template-body") || "";
    const modal = $(this);

    modal.find("#template_id").val(templateId);

    if (templatePreview.length) {
        if (name || body) {
            templateName.text(name);
            templateBody.text(body);
            templateLength.text(`${body.length} characters`);
            templatePreview.removeClass("d-none");
        } else {
            templatePreview.addClass("d-none");
        }
    }

    updateClientCount();
});

$(document).on("click", ".js-toggle-credential", function () {
    const $button = $(this);
    const targetKey = $button.data("target");
    const fullValue = $button.data("full");
    const state = $button.attr("data-state");
    const $icon = $button.find("i");
    const $value = $(`#credential-value-${targetKey}`);

    if (!$value.length) {
        return;
    }

    const defaultValue = $value.data("default");

    if (state === "masked") {
        $value.text(fullValue);
        $button.attr("data-state", "visible");
        $icon.removeClass("fa-eye").addClass("fa-eye-slash");
        $button.attr("aria-label", "Hide password");
        $button.attr("title", "Hide password");
    } else {
        $value.text(defaultValue);
        $button.attr("data-state", "masked");
        $icon.removeClass("fa-eye-slash").addClass("fa-eye");
        $button.attr("aria-label", "Show password");
        $button.attr("title", "Show password");
    }
});

bulkSmsSendForm.on("hidden.bs.modal", function () {
    const form = $(this).find("#sms-form")[0];

    if (form) {
        form.reset();
    }

    if (templatePreview.length) {
        templatePreview.addClass("d-none");
        templateName.text("");
        templateBody.text("");
        templateLength.text("0 characters");
    }

    updateClientCount();
});

$("button.checkBalance").on('click',(e)=>{
    e.preventDefault();
    const {provider} = e.currentTarget.dataset;
    window.axios.post('/sms-providers/check-balance',{provider_id:provider})
    .then(({data}) => {
        if(parseInt(data.statusCode) !== 200){
            window.toastr.error(data.responseResult,data.status);
            return;
        }
        window.toastr.success(data.responseResult,'Balance');
        return;
    }).catch(e=>{
        console.log(e);
        window.toastr.error('Something went wrong','Error');
    });
});